import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "app" };
import AppHeader from './components/layout/AppHeader.vue';
import AppFooter from './components/layout/AppFooter.vue';
import { useI18n } from './composables/useI18n';
import { ref, watch, onMounted, onUnmounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import CookieConsentModal from './components/layout/CookieConsentModal.vue';
import CookieInfoModal from './components/layout/CookieInfoModal.vue';
import { useCookieConsent } from './composables/useCookieConsent';
import { EnvChecker } from './utils/env-checker';
import SimpleBird from './components/SimpleBird.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const { t } = useI18n();
        const route = useRoute();
        const isSpecialPage = computed(() => {
            return route.name === 'Congratulations' || route.name === 'MiniGame';
        });
        const activeSection = ref('hero');
        const updateActiveSectionFromHash = () => {
            if (isSpecialPage.value)
                return;
            if (route.path === '/') {
                const hash = window.location.hash.replace('#', '');
                if (hash && ['hero', 'values', 'games', 'news', 'blog', 'contact'].includes(hash)) {
                    activeSection.value = hash;
                }
                else {
                    activeSection.value = 'hero';
                }
            }
            else if (route.path.startsWith('/blog/')) {
                activeSection.value = 'blog';
            }
        };
        watch(() => route.path, () => {
            updateActiveSectionFromHash();
        }, { immediate: true });
        const handleHashChange = () => {
            if (route.path === '/' && !isSpecialPage.value) {
                updateActiveSectionFromHash();
            }
        };
        onMounted(() => {
            if (import.meta.env.DEV) {
                EnvChecker.printConfig();
            }
            window.addEventListener('hashchange', handleHashChange);
            updateActiveSectionFromHash();
        });
        onUnmounted(() => {
            window.removeEventListener('hashchange', handleHashChange);
        });
        const { showConsentModal, showInfoModal, acceptAllCookies, acceptNecessaryOnly, showCookieInfo, hideCookieInfo } = useCookieConsent();
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!isSpecialPage.value)
                    ? (_openBlock(), _createBlock(AppHeader, {
                        key: 0,
                        "active-section": activeSection.value
                    }, null, 8, ["active-section"]))
                    : _createCommentVNode("", true),
                _createVNode(_component_router_view),
                (!isSpecialPage.value)
                    ? (_openBlock(), _createBlock(AppFooter, {
                        key: 1,
                        t: _unref(t)
                    }, null, 8, ["t"]))
                    : _createCommentVNode("", true),
                (!isSpecialPage.value)
                    ? (_openBlock(), _createBlock(SimpleBird, { key: 2 }))
                    : _createCommentVNode("", true),
                (_unref(showConsentModal) && !isSpecialPage.value)
                    ? (_openBlock(), _createBlock(CookieConsentModal, {
                        key: 3,
                        visible: _unref(showConsentModal),
                        position: "bottom",
                        t: _unref(t),
                        onAccept: _unref(acceptAllCookies),
                        onNecessaryOnly: _unref(acceptNecessaryOnly)
                    }, null, 8, ["visible", "t", "onAccept", "onNecessaryOnly"]))
                    : _createCommentVNode("", true),
                (_unref(showInfoModal) && !isSpecialPage.value)
                    ? (_openBlock(), _createBlock(CookieInfoModal, {
                        key: 4,
                        visible: _unref(showInfoModal),
                        t: _unref(t),
                        onClose: _unref(hideCookieInfo)
                    }, null, 8, ["visible", "t", "onClose"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
